import React from 'react';
import RouterLinkFormatter from './RouterLinkFormatter';
import { LinkProps } from './types';

const HistoryTrxLink: React.FC<LinkProps> = ({ id }) => {
	const LinkFormatter = RouterLinkFormatter((value: string) => `/history?transactionId=${value}`);
	return <LinkFormatter value={id} record={{ value: id }} />;
};

export default HistoryTrxLink;
